// ElementControls.js

import React from 'react';

export default function ElementControls({ addElement, generateCalendar, selected, handleChange }) {
  return (
    <div style={{ width: '250px', marginRight: '1rem' }}>
      <div style={{ marginBottom: '1rem' }}>
        <button onClick={() => addElement('text')}>Add Text</button>
        <button onClick={() => addElement('checkbox')}>Add Checkbox</button>
        <button onClick={() => addElement('line')}>Add Line</button>
        <button onClick={() => addElement('box')}>Add Box</button>
        <button onClick={generateCalendar}>Add Calendar (from Box)</button>
      </div>

      {selected && (
        <div style={{ padding: '10px', border: '1px solid #ccc', background: '#f9f9f9' }}>
          <h4>Edit Element</h4>
          {['text', 'checkbox'].includes(selected.type) && (
            <>
              <label>Text:</label>
              <input type="text" value={selected.text} onChange={(e) => handleChange('text', e.target.value)} />
              <br />
              <label>Font Size:</label>
              <input type="number" value={selected.fontSize} onChange={(e) => handleChange('fontSize', parseInt(e.target.value))} />
            </>
          )}
          {selected.type === 'line' && (
            <>
              <label>Length:</label>
              <input type="number" value={selected.points[2]} onChange={(e) => handleChange('points', [0, 0, parseInt(e.target.value), 0])} />
              <br />
              <label>Thickness:</label>
              <input type="number" value={selected.strokeWidth} onChange={(e) => handleChange('strokeWidth', parseInt(e.target.value))} />
            </>
          )}
          {selected.type === 'box' && (
            <>
              <label>Width:</label>
              <input type="number" value={selected.width} onChange={(e) => handleChange('width', parseInt(e.target.value))} />
              <br />
              <label>Height:</label>
              <input type="number" value={selected.height} onChange={(e) => handleChange('height', parseInt(e.target.value))} />
              <br />
              <label>Stroke Width:</label>
              <input type="number" value={selected.strokeWidth} onChange={(e) => handleChange('strokeWidth', parseInt(e.target.value))} />
            </>
          )}
        </div>
      )}
    </div>
  );
}
